module.exports = __webpack_public_path__ + "abd9ef7aa3fead216cb6fb0ecfbb21d8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared/fontello/font/fontello.woff
// module id = 2754
// module chunks = 66